import { createRoute } from '@tanstack/react-router';

import { AlertsPage } from '@web/ui/alerts';

import { orgWorkspaceLayoutRoute } from './overview_routes';

/**
 * `/orgs/$orgSlug/alerts` — flight-alerts panel: flights in an anomalous
 * state (cancelled, diverted, delayed, connection at risk/missed, schedule
 * changed) that need operator attention in the next 24 hours.
 */
export const alertsRoute = createRoute({
  getParentRoute: () => orgWorkspaceLayoutRoute,
  path: 'alerts',
  component: AlertsPage,
});
